export default function Experience({ experience, setEnabled }) {
    function formatDate(date) {
        return [
            ("0" + (date.getMonth()+1)).slice(-2),
            date.getFullYear()
        ].join(" / ")
    }

    function clickHandler(e, b) {
        let node = e.currentTarget
        let newValue = setEnabled()

        newValue ? 
            node.classList.remove('disabled') :
            node.classList.add('disabled') 
    }

    return (
        <div className="experience">
            <div className="etablissement" onClick={clickHandler}>
                <p className={ experience.type }>{ experience.name }</p>
                <p className="period">
                    <span className="start">{ formatDate(experience.start) }</span>
                    <span className="sperator"></span>
                    <span className="end">{ formatDate(experience.end) }</span>
                </p>
                <p className="subtitle">
                    {
                        experience.subtitle.map((subtitle, i) => {
                            return (
                                <span key={"subtitle-" + experience.name +"-"+i}>
                                    { subtitle }
                                </span>
                            )
                        })
                    }
                </p>
            </div>
        </div>
    )
}